export default __webpack_public_path__ + "62b2ed526a1626e2b6676977ff35930c.svg";